// import React, { useEffect, useState } from 'react';
// import Loader from '../Shared/Loader';
// import play from '../../assets/images/play.png';
// import ReactPaginate from 'react-paginate';
// import { FaAssistiveListeningSystems } from 'react-icons/fa';
// import { AiOutlineDownload } from 'react-icons/ai';


// const MobileShorts = ({ setAudioData }) => {
//     const [shorts, setShorts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchResult, setSearchResult] = useState([]);
//     const [isSearching, setIsSearching] = useState(false);
//     const [pageCount, setPageCount] = useState(0);
//     const [start, setStart] = useState(0);
//     const [end, setEnd] = useState(20);

//     useEffect(() => {
//         fetch(`https://madrumi.thakurgaonexpress.com/getshorts`)
//             .then(res => res.json())
//             .then(data => {
//                 setPageCount(Math.ceil(data.length / 20));
//             })
//     }, [])

//     useEffect(() => {
//         fetch(`https://madrumi.thakurgaonexpress.com/getshorts`)
//             .then(res => res.json())
//             .then(data => {
//                 setShorts(data);
//                 setLoading(false)
//             })
//     }, [])

//     if (loading) {
//         return <Loader />
//     }

//     const handleSearchResult = (event) => {
//         const searchText = event.target.value;
//         const match = shorts.filter(short => short.name.includes(searchText));
//         setSearchResult(match);
//         setIsSearching(true);
//     }

//     const handlePlayAudio = (short) => {
//         setAudioData(short);
//         const newView = short.view ? short.view : 0;
//         const view = parseInt(newView) + 1;
//         const viewCount = { view };

//         fetch(`https://madrumi.thakurgaonexpress.com/getshort/${short?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(viewCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);

//             })

//     }
//     const handleDownloadCount = (short) => {
//         const newDownload = short.download ? short.download : 0;
//         const download = parseInt(newDownload) + 1;
//         const downloadCount = { download };

//         fetch(`https://madrumi.thakurgaonexpress.com/getshort/${short?._id}`, {
//             method: 'PATCH',
//             headers: {
//                 'content-type': 'application/json'
//             },
//             body: JSON.stringify(downloadCount)
//         })
//             .then(res => res.json())
//             .then(data => {
//                 console.log(data);
//             })

//     }


//     let st = 0;
//     let en = 20;

//     const handlePageClick = (data) => {
//         if (data.selected + 1 < 3) {
//             st = st * data.selected + 1 * 20;
//         } else {
//             st = st * data.selected + 1 * 20 + 20;
//         }

//         if (data.selected + 1 <= 1) {
//             st = 0
//             en = 20
//         }
//         en = en * data.selected + 20;
//         setStart(st);
//         setEnd(en);
//         window.scrollTo(0, 0);
//     }

//     const reloadFn = () => {
//         setStart(st);
//         setEnd(en);
//     }

//     return (
//         <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
//             <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>মুফতি শফি সাহেব (দাঃ বাঃ)এর ছোট বয়ান সমূহ</h1><br />
//             <div className='flex justify-center items-center my-4'>
//                 <div class="form-control w-80">
//                     <label class="label">
//                         <span class="label-text font-bold">ছোট বয়ানের নাম লিখে অনুসন্ধান করুন</span>
//                     </label>
//                     <input onMouseDown={reloadFn} onChange={handleSearchResult} type="text" placeholder="ছোট বয়ানের নাম লিখুন" class="input input-bordered input-accent w-full max-w-xs" />
//                 </div>
//             </div>

//             <hr />
//             <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
//                 {
//                     isSearching ? searchResult.slice(start, end).map(short => <div style={{ height: '370px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {short.name}</h3>
//                         <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {short.date}<span className='font-bold'>  বিভাগঃ</span> {short.subject}</h3>
//                         <p className='my-4'>{short.description}</p>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{short?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{short?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(short)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={() => handleDownloadCount(short)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={short.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>) : shorts.slice(start, end).map(short => <div style={{ height: '370px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
//                         <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {short.name}</h3>
//                         <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {short.date}<span className='font-bold'>  বিভাগঃ</span> {short.subject}</h3>
//                         <p className='my-4'>{short.description}</p>
//                         <div className='flex flex-row'>
//                             <FaAssistiveListeningSystems className='text-xs' />
//                             <p className='ml-px text-xs'>{short?.view}</p>
//                             <AiOutlineDownload className='text-xs ml-2' />
//                             <p className='ml-px text-xs'>{short?.download}</p>
//                         </div>
//                         <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
//                             <label onClick={() => handlePlayAudio(short)} for="my-modal-6" class="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন
//                             </label>
//                             <label onClick={() => handleDownloadCount(short)} for="my-modal-6" class="btn btn-accent text-white font-bold mr-2"><a href={short.link}>ডাউনলোড</a>
//                             </label>
//                         </div>
//                     </div>)
//                 }
//             </div>
//             <div className='mt-8 mb-20'>
//                 {shorts.length > 20 && <ReactPaginate
//                     previousLabel={'পূর্ববর্তী'}
//                     nextLabel={'পরবর্তী'}
//                     breakLabel={'...'}
//                     pageCount={pageCount}
//                     marginPagesDisplayed={3}
//                     pageRangeDisplayed={6}
//                     onPageChange={handlePageClick}
//                     containerClassName={'btn-group justify-center'}
//                     pageClassName={'btn btn-accent text-white'}
//                     activeClassName={'btn bg-white text-black'}
//                     previousClassName={'btn btn-accent text-white'}
//                     nextClassName={'btn btn-accent text-white'}
//                     breakClassName={'btn btn-accent text-white'}></ReactPaginate>}
//             </div>
//         </div >
//     );
// };

// export default MobileShorts;


import React, { useEffect, useState } from 'react';
import Loader from '../Shared/Loader';
import ReactPaginate from 'react-paginate';
import { FaAssistiveListeningSystems } from 'react-icons/fa';
import { AiOutlineDownload } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { openDB } from 'idb';

const MobileShorts = ({ setAudioData }) => {
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [downloadProgress, setDownloadProgress] = useState({});
    const [downloadComplete, setDownloadComplete] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [shorts, setShorts] = useState([]); // Store the shorts fetched from backend
    const [totalShorts, setTotalShorts] = useState(0); // Store total shorts from backend

    const limit = 10; // Number of shorts per page

    // Load downloaded files status from localStorage on component mount
    useEffect(() => {
        const downloadedFiles = JSON.parse(localStorage.getItem('downloadedFiles')) || {};
        setDownloadComplete(downloadedFiles);

        // Fetch shorts from backend initially
        fetchKobitasFromBackend(currentPage, "");
    }, [currentPage]); // Fetch shorts when the page changes

    // Fetch shorts from backend with pagination, search
    const fetchKobitasFromBackend = async (page = 1, search = "") => {
        setIsLoading(true);
        try {
            const response = await fetch(`https://madrumi.thakurgaonexpress.com/getshortswithfilter?page=${page}&limit=${limit}&search=${search}`);
            const data = await response.json();
            setShorts(data.total); // Set shorts based on the fetched data
            setPageCount(Math.ceil(data.document / limit)); // Set total pages based on document count
            setTotalShorts(data.document); // Store total shorts count
        } catch (error) {
            console.error("Error fetching shorts:", error);
        }
        setIsLoading(false);
    };

    // Handle search input
    const handleSearchResult = (event) => {
        const searchText = event.target.value;
        setIsSearching(true);
        fetchKobitasFromBackend(1, searchText); // Updated to only pass searchText
    };

    const handlePlayAudio = (shorts) => {
        setAudioData(shorts);
        const newView = shorts.view ? shorts.view : 0;
        const view = parseInt(newView) + 1;
        const viewCount = { view };

        fetch(`https://madrumi.thakurgaonexpress.com/getshort/${shorts?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(viewCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };

    // Initialize IndexedDB
    const initDB = async () => {
        const db = await openDB('AudioDB', 1, {
            upgrade(db) {
                const store = db.createObjectStore('audioFiles', { keyPath: '_id' });
                store.createIndex('name', 'name', { unique: false });
            }
        });
        return db;
    };

    const handleDownloadAndSave = async (shorts) => {
        const db = await initDB();

        // Check if the file has already been downloaded
        if (downloadComplete[shorts._id]) {
            return;
        }

        const audioBlob = await fetchAudioFile(shorts.link, shorts._id); // Download audio file as Blob

        // Save Blob and question to IndexedDB with the required _id key
        await db.put('audioFiles', { blob: audioBlob, type: 'ছোট বয়ান', name: shorts.name }, shorts._id);

        const updatedDownloadComplete = { ...downloadComplete, [shorts._id]: true };
        setDownloadComplete(updatedDownloadComplete); // Mark the file as downloaded

        // Store updated status in localStorage
        localStorage.setItem('downloadedFiles', JSON.stringify(updatedDownloadComplete));

        handleDownloadCount(shorts);

        // Show success toast notification
        toast.success('File downloaded successfully!');
    };

    const fetchAudioFile = async (url, id) => {
        const response = await fetch(url);
        const reader = response.body.getReader();
        const contentLength = +response.headers.get('Content-Length');

        let receivedLength = 0; // Received length of data
        let chunks = []; // Array to hold the downloaded chunks

        while (true) {
            const { done, value } = await reader.read();

            if (done) break;

            chunks.push(value);
            receivedLength += value.length;

            // Calculate and set download progress for the specific file
            const progress = (receivedLength / contentLength) * 100;
            setDownloadProgress(prev => ({ ...prev, [id]: progress }));
        }

        // Create Blob from downloaded chunks
        const blob = new Blob(chunks);
        return blob;
    };

    const handleDownloadCount = (shorts) => {
        const newDownload = shorts.download ? shorts.download : 0;
        const download = parseInt(newDownload) + 1;
        const downloadCount = { download };

        fetch(`https://madrumi.thakurgaonexpress.com/getshort/${shorts?._id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(downloadCount)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
            });
    };

    // Handle pagination page click
    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1); // Update the current page
        window.scrollTo(0, 0);
    };

    return (
        <div className='w-10/12 lg:w-11/12 mx-auto mt-16 relative'>
            <ToastContainer />
            <h1 className='text-xl border-b-4 border-accent font-bold mt-8 inline-block'>মুফতি শফি সাহেব (দাঃ বাঃ)এর ছোট বয়ান সমূহ</h1><br />
            <div className='flex justify-center items-center my-4'>
                <div class="form-control w-80">
                    <label class="label">
                        <span class="label-text font-bold">ছোট বয়ানের নাম লিখে অনুসন্ধান করুন</span>
                    </label>
                    <input onChange={handleSearchResult} type="text" placeholder="ছোট বয়ানের নাম লিখুন" class="input input-bordered input-accent w-full max-w-xs" />
                </div>
            </div>
            <hr />

            {/* Show Loader */}
            {isLoading ? (
                <Loader />
            ) : (
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
                    {shorts.length > 0 ? shorts.map(short => (
                        <>
                            <div key={short._id} style={{ height: '290px' }} className='shadow-xl bg-white hover:shadow-accent active:shadow-red-400 p-5 rounded-r-3xl rounded-tl-3xl text-left relative'>
                                <h3 className='text-lg font-bold min-h-8'>বয়ানের বিষয়ঃ {short.name}</h3>
                                <h3 className='text-base'><span className='font-bold'>তারিখঃ</span> {short.date}<span className='font-bold'>  বিভাগঃ</span> {short.subject}</h3>
                                <p className='my-4'>{short.description}</p>
                                <div className='flex flex-row'>
                                    <FaAssistiveListeningSystems className='text-xs' />
                                    <p className='ml-px text-xs'>{short?.view}</p>
                                    <AiOutlineDownload className='text-xs ml-2' />
                                    <p className='ml-px text-xs'>{short?.download}</p>
                                </div>
                                <div className='mt-4 text-center absolute bottom-6 rounded-2xl left-12 shadow-2xl p-2'>
                                    <label onClick={() => handlePlayAudio(short)} htmlFor="my-modal-6" className="btn btn-accent btn-circle text-white font-bold mr-12">শুনুন</label>
                                    <label
                                        onClick={() => handleDownloadAndSave(short)}
                                        className={`btn ${downloadComplete[short._id] ? 'btn-gray text-gray-500 cursor-not-allowed' : 'btn-accent text-white font-bold'}`}
                                        disabled={downloadComplete[short._id]}
                                    >
                                        {downloadComplete[short._id] ? 'ডাউনলোড হয়েছে' : 'ডাউনলোড'}
                                    </label>
                                </div>
                                {downloadProgress[short._id] && downloadProgress[short._id] < 100 && (
                                    <div className='progress' style={{ backgroundColor: '#f0f0f0', borderRadius: '8px', height: '10px', marginTop: '2px' }}>
                                        <div
                                            className='progress-bar'
                                            role='progressbar'
                                            style={{
                                                width: `${Math.max(downloadProgress[shorts._id], 1)}%`,
                                                backgroundColor: '#4caf50', // Set your preferred color here
                                                height: '100%',
                                                borderRadius: '8px',
                                                transition: 'width 0.5s ease' // Smooth transition
                                            }}
                                        >
                                            {Math.round(downloadProgress[short._id])}%
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )) : (
                        <div className='text-center text-2xl font-bold'>কোন কবিতা পাওয়া যায়নি!</div>
                    )}
                </div>
            )}

            {/* Pagination */}
            <div className="flex justify-center mt-5 mb-20 flex-wrap">
                {pageCount > 0 && (
                    <ReactPaginate
                        previousLabel={<span className="text-gray-700">Previous</span>}
                        nextLabel={<span className="text-gray-700">Next</span>}
                        breakLabel={<span className="text-gray-700">...</span>}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"flex space-x-2 flex-wrap"}
                        pageClassName={"flex items-center justify-center bg-white border border-gray-300 hover:bg-gray-200 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        previousClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        nextClassName={"flex items-center justify-center bg-gray-200 border border-gray-300 text-gray-700 font-medium py-1 px-2 rounded-md cursor-pointer"}
                        breakClassName={"flex items-center justify-center text-gray-700 font-medium py-1 px-2"}
                        activeClassName={"bg-accent text-white font-bold"}
                        disabledClassName={"bg-gray-300 text-gray-500 cursor-not-allowed"}
                    />
                )}
            </div>
        </div>
    );
};

export default MobileShorts;
